import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">
      <a href="https://www.worktualize.com/" target="_blank">Worktualize</a> {{year}}
    </span>
  `,
})
export class FooterComponent implements OnInit{
  
  year: any;
  
  ngOnInit() {
    /** Prints current year */
    this.year = new Date().getFullYear();
  }
}
